import DesktopMonthPicker from './desktop-month-picker'

export default DesktopMonthPicker
